import { Component, Input } from '@angular/core';
import { ChangeControlDetailsService } from '../../services/change-control-details.service';

@Component({
  selector: 'app-change-control-attachment',
  templateUrl: './change-control-attachment.component.html',
  styleUrls: ['./change-control-attachment.component.scss']
})
export class ChangeControlAttachmentComponent {
  @Input() openAttachmentModal:boolean=false;
  @Input() attachmentsData:any;


  constructor(private changeControlDetailsService: ChangeControlDetailsService){

  }

  ngOnInit(){
  }

  downloadAttachment = (fileId: string, fileName: string) => {
    this.changeControlDetailsService.downloadFile(fileId).subscribe((response) => {
      const fileUrl = response.fileUri;
      let downloadLink = document.createElement('a');
      document.body.appendChild(downloadLink);
      downloadLink.setAttribute('style', 'display: none');
      downloadLink.href = fileUrl;
      downloadLink.download = fileName;
      downloadLink.target = '_blank';
      downloadLink.click();
      downloadLink.remove();
    })
  }
}
